import CommonAction from '../../shared/Http/Http';
import {TENANT_UPDATE} from '../constants';


export const editTenant = body => CommonAction('PUT', null, `backoffice-extended/tenants/update`, TENANT_UPDATE, body);